import React from "react";
import amaxText from "../images/amaxText.png";
import amaxTextWhite from "../images/amaxTextWhite.png";
import userman from "../images/userman.png";
import { Link, useLocation } from "react-router-dom";
export const UserHeader = () => {
  const location = useLocation();
  const isActive = (path: any) => location.pathname === path;

  return (
    <div className={`${isActive("/split") ? "bg-black" : "" }`}>
    <div
      className={`flex flex-row justify-between items-center gap-5 w-full max-w-screen-xl mx-auto pb-2 pt-2 px-5`}
    >
      <Link to="/" className="w-full max-w-[93px] block">
        {location.pathname === "/split" ? (
          <img
            src={amaxTextWhite}
            alt="amax"
            className="object-contain w-full"
          />
        ) : (
          <img src={amaxText} alt="amax" className="object-contain w-full" />
        )}
      </Link>

      <div className="size-[60px] rounded-full relative cursor-pointer">
        <img
          src={userman}
          alt="user"
          className="object-cover w-full rounded-full"
        />
        <span className={`${isActive("/split") ? "!bg-white !text-black" : ""} bg-[#0d0d0d] p-1 min-h-3 min-w-5 text-white text-[10px] font-bold rounded-full flex justify-center items-center absolute top-0 right-0 z-10`}>
          2
        </span>
      </div>
    </div>
    </div>
  );
};

// amaxTextWhite
